import ExamImage from "../components/ExamImage";
import { useState } from "react";
import QuestionLayout from "./QuestionLayout";
import SymbolPalette from "./staff/SymbolPalette";
import { Glyph } from "./staff/glyphs.jsx";

export default function SumSymbolWidget({
  config,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  const [activeRow, setActiveRow] = useState(null);

  function placeSymbol(symbol) {
    if (!activeRow || mode !== "edit") return;

    onChange({
      ...value,
      [activeRow]: { symbol }
    });

    setActiveRow(null);
  }

  function clearRow(rowId) {
    const next = { ...value };
    delete next[rowId];
    onChange(next);
  }

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
      legendImage={config.legendImage}
    >
      {/* PALETTE */}
      {mode === "edit" && (
        <SymbolPalette
          allowedSymbols={config.allowedSymbols}
          selected={null}
          onSelect={placeSymbol}
        />
      )}

      <div style={{ maxWidth: 560 }}>
        {config.rows.map((row, i) => {
          const entry = value[row.id];
          const part = feedback?.parts?.[row.id];
          const isReview = mode === "review";
          const isCorrect = part?.correct === true;
          const isIncorrect = part?.correct === false;

          return (
            <div
              key={row.id}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr auto 80px",
                alignItems: "center",
                gap: 14,
                marginBottom: 16
              }}
            >
              {/* IMAGE */}
              <ExamImage
                src={row.image}
                alt={`sum-${i + 1}`}
                style={{
                  maxHeight: 60,
                  maxWidth: "100%",
                  objectFit: "contain"
                }}
              />

              {/* = */}
              <div style={{ fontSize: 22, fontWeight: 600 }}>=</div>

              {/* INPUT SLOT */}
              <svg
                width={72}
                height={72}
                style={{
                  borderRadius: 6,
                  cursor: mode === "edit" ? "pointer" : "default",

                  border: isCorrect
                    ? "2px solid #2e7d32"
                    : isIncorrect
                    ? "2px solid #c62828"
                    : "2px solid #aaa",

                  background: isCorrect
                    ? "#e8f5e9"
                    : isIncorrect
                    ? "#fdecea"
                    : activeRow === row.id
                    ? "#e6f0ff"
                    : "#fff"
                }}
                onClick={() => {
                  if (mode !== "edit") return;
                  if (entry) clearRow(row.id);
                  else setActiveRow(row.id);
                }}
              >
                {entry?.symbol && (
                  <g transform="translate(30, 50)">
                    <Glyph symbol={entry.symbol} />
                  </g>
                )}

                {!entry && activeRow !== row.id && !isReview && (
                  <text
                    x="36"
                    y="42"
                    textAnchor="middle"
                    fontSize="11"
                    fill="#999"
                  >
                    click
                  </text>
                )}
              </svg>
            </div>
          );
        })}
      </div>
    </QuestionLayout>
  );
}
